import { useCallback, useState } from 'react';
import { useApi, useMutation } from './useApi';
import { getAlerts, updateAlert, AlertFilters } from '../services/api';
import { Alert, PaginatedResponse, UpdateAlertRequest } from '../types';

export function useAlerts(initialFilters: AlertFilters = {}) {
  const [filters, setFilters] = useState<AlertFilters>(initialFilters);

  const fetchAlerts = useCallback(() => getAlerts(filters), [filters]);

  const { data, loading, error, refetch } = useApi<PaginatedResponse<Alert>>(
    fetchAlerts,
    [JSON.stringify(filters)]
  );

  return {
    alerts: data?.items || [],
    total: data?.total || 0,
    page: data?.page || 1,
    totalPages: data?.totalPages || 1,
    loading,
    error,
    filters,
    setFilters,
    refetch,
  };
}

export function useUpdateAlert() {
  const { mutate, loading, error, data, reset } = useMutation<
    Alert,
    { id: string; data: UpdateAlertRequest }
  >(({ id, data }) => updateAlert(id, data));

  return {
    updateAlert: mutate,
    loading,
    error,
    updatedAlert: data,
    reset,
  };
}
